import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    memo: {
        name: () => '简述',
    },

    moduleType: {
        name: () => '模件类型',
        required: () => true,
    },

    reqTitle: {
        name: () => '需求项标题',
        required: () => true,
    },

    reqType: {
        name: () => '需求项类型',
        readOnly: (map, node) => void 0 !== node.data.pkid,
        required: () => true,
    },
})
